import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import 'react-toastify/dist/ReactToastify.css'
import { getTicketDetails } from '../../redux/actions/userDetails'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'
import {phoneMasker} from '../../utils/helper'
import { QRCodeSVG } from 'qrcode.react'
import {  useParams } from 'react-router-dom'
import Loader from '../../global/Loader'
import NoData from '../../components/NoData'
import Footer from '../../components/global/Footer'
import MiniHeader from '../../components/global/MiniHeader'
import { errorMessage } from '../../constants/errorMessage'
import { getConfigDetails } from '../../services/config'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import { addEventLog } from '../../redux/actions/EventsLog'
import CONSTANTS from '../../redux/constants'
// import { endParking } from '../../redux/actions/transientAction'
// import { Circles } from 'react-loader-spinner'

function Ticket(props) {
	const { dispatch, ticketDetailsFromProps , loader, notify} = props
	const [ticketDetails, setTicketDetails] = useState('')
	const [error, setError] = useState('')
	const {ticketId,partner} = useParams()

	
	useEffect(() => {
		if(partner){
			if(ticketDetailsFromProps && ticketDetailsFromProps?.ticket_number != ''){
				setTicketDetails(ticketDetailsFromProps)
			}else{
				if(ticketId){
					const payload = {
						'ticket': ticketId,
						'phone': '',
						'cardLast4': '',
						'cardExpiry': '',
						'license_plate': ''
					}
					dispatch(getTicketDetails(payload)).then((res) => {
						if (res?.status === 201 || res?.status === 200) {
							if (res?.data && res?.data != null) {
								// notify('success', 'T successfully')
								setTicketDetails(res?.data)
							} else {
								notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong) 
								let errObject = { 
									payload: payload,
									error: res,
									errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
								}
								dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-Ticket.js-42`))
							}
						} else {
							setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
							notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
							let errObject = { 
								payload: payload,
								error: res,
								errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
							}
							dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-Ticket.js-42`))
						}
					}).catch((err) => {
						let errObject = { 
							payload: payload,
							error: err,
							errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
						}
						dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-Ticket.js-42`))
						notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
					})
				}else{
					setTicketDetails('')
				}
			}
		}
		
		
	},[ticketDetailsFromProps])


	// const handleEndParking = () => {
	// 	dispatch(endParking(ticketDetails?.ticket_number)).then((res) => {
	// 		if (res?.status === 201 || res?.status === 200) {
	// 			if (res?.data && res?.data != null) {
	// 				// notify('success', 'T successfully')
	// 				setTicketDetails(res?.data)
	// 			} else {
	// 				notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
	// 			}
	// 		} else {
	// 			setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
	// 			notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
	// 		}
	// 	}).catch(() => {
	// 		notify('error', errorMessage?.somethingWentWrong)
	// 	})
	// }
	return (
		<div className={ticketId ? 'main' : ''}>
			{ticketId && <MiniHeader/>}
			{(partner) ? loader ? <Loader/> : (ticketDetails.length > 0) ? <div className="card shadow-lg mb-5 bg-white rounded border-0">
					<div className="card-header bg-white row p-1 m-0">
						<div className='col-7'>
							<p className="pull-left my-2 add-member-plan text-primary fw-bold small">{ticketDetails?.facility?.full_name}</p>
							<p className="pull-left my-2 add-member-plan small">{ticketDetails?.facility?.entrance_location}</p>
						</div>
						<div className='col-5 d-flex align-items-center justify-content-center small'>
						{ticketDetails?.facility?.garage_code && <p className="my-2 rounded-pill bg-dark ps-3 pe-3 text-white d-flex pt-1 pb-1 small h5">CODE: {ticketDetails?.facility?.garage_code}</p>}
						</div>
						
					</div>
					<div className="card-body">
						<div className="clearfix example">
							<p className='text-center text-primary small h5'>Thank you for parking with us.</p>
							<div className='responsive-canvas mt-3 mb-2'>
								{ticketDetails?.ticket_number && (
									<QRCodeSVG
									value={`${window?.location?.toString()?.('rev-pass') ? getConfigDetails()?.revpartnerUrl : window?.location?.toString()?.includes('breeze') ? getConfigDetails()?.pcipartnerUrl : getConfigDetails()?.partnerUrl}/admin/tickets?ticket_number=${ticketDetails?.ticket_number}`}
									width="100%"
									height="100%"
									// size={180}
									/>
								)}
								<span className="d-flex justify-content-center mt-2">
									<b>#{ticketDetails?.ticket_number}</b>
								</span>
							</div>
							<div className='col-10 m-auto border rounded row small text-muted text-center pt-2 pb-2'>
								<div className='col-6 border-end small'>
									Start Time
									<span className='d-block text-primary fw-bold small'>{ticketDetails?.check_in_datetime ? moment(ticketDetails?.check_in_datetime).format('Do MMM YYYY h:mmA') : '-'}</span>
								</div>
								<div className='col-6 small'>
									End Time
									<span className='d-block text-primary fw-bold small'>{ticketDetails?.checkout_datetime ? moment(ticketDetails?.checkout_datetime).format('Do MMM YYYY h:mmA') : '-'}</span>
								</div>
							</div>

							<p className='text-primary fw-bold mt-4 h6'>Customer Information</p>
							<div className='col-12 m-auto border rounded row small text-muted pt-2 pb-2'>
								{/* <div className='col-6 border-end small p-2'>
									<div className='row'>
										<div className='col-auto fw-bold'>Name</div>
										<div className='col'>{ticketDetails?.user?.name ? ticketDetails?.user?.name : '-'}</div>
									</div>
								</div> */}
								<div className='col small border-end ms-1 p-2'>
									<div className='row'>
										<div className='col-auto fw-bold'>Mobile</div>
										<div className='col-auto'>{ticketDetails?.user?.phone ? phoneMasker(ticketDetails?.user?.phone) : '-'}</div>
									</div>
								</div>
								{/* <div className='col-6 border-end border-top small p-2'>
									<div className='row'>
										<div className='col-auto fw-bold'>Email</div>
										<div className='col'>{ticketDetails?.user?.email ? ticketDetails?.user?.email : '-'}</div>
									</div>
								</div> */}
								<div className='col small ms-1 p-2'>
									<div className='row'>
										<div className='col-6 fw-bold'>License</div>
										<div className='col-auto col-sm-6'>{ticketDetails?.license_plate ? ticketDetails?.license_plate : '-'}</div>
									</div>
								</div>
							</div>
							{ticketDetails?.is_expired == '0' && <div className='mt-3 m-auto'>
								{(partner) && <div className='small'>
									<a 
										href={`${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revtransientURL : window?.location?.toString()?.includes('breeze') ? getConfigDetails()?.pcitransientURL : getConfigDetails()?.transientURL}/${partner}/extend/${ticketDetails?.ticket_number}`} 
										type='button' 
										className='text-decoration-none w-100 border bg-white text-center text-primary border-primary rounded ps-4 pe-4 fw-bold pt-2 pb-2'>
										<i className='fa fa-plus-circle'></i> Extend
									</a>
								</div>}
								{/* <div className='col-6 small'>
									<button 
										type='button' 
										className='text-decoration-none border w-100 bg-white text-center text-primary border-primary rounded ps-4 pe-4 fw-bold pt-2 pb-2'
										onClick={()=>handleEndParking()}>
										<div className='d-flex justify-content-center align-items-center'>
											<span>End Parking</span>
											<span className='ms-2'>
											{isFetching ? <Circles
												height="20"
												width="20"
												style={{ display: 'inline-block' }}
												color="#26A8E0"
												ariaLabel="circles-loading"
												visible={true}
											/> : null}
											</span>
										</div>
									</button>
								</div> */}
							</div>}
						</div>
					</div>
					<div className="card-footer row p-2 m-0 bg-primary">
						<div className='col-7 d-flex align-items-center justify-content-left'>
							<p className=" text-right my-2 text-white fw-bold">Paid Amount</p>
						</div>
						<div className='col-5 d-flex align-items-center justify-content-end'>
							<p className="my-2 ps-3 pe-3 text-white d-flex pt-1 pb-1 small h5">{ticketDetails?.grand_total ? `$${ticketDetails?.grand_total}` : 'NA'}</p>
						</div>
						
					</div>
				</div>: error && <NoData message={error}/>
			: <NoData message={errorMessage?.invalidPartner}/>}
			{ticketId && <Footer/>}
		</div>
		
	)
}


Ticket.propTypes = {
	dispatch: PropTypes.func,
	loader: PropTypes.bool,
	loaderSms: PropTypes.bool,
	loaderDownload: PropTypes.bool,
	isFetching: PropTypes.bool,
	ticketDetailsFromProps: PropTypes.object,
	notify: PropTypes.func,
}

Ticket.defaulProps = {
	dispatch: noop,
	loader: false,
	isFetching: false,
	ticketDetailsFromProps: EMPTY_OBJECT,
	notify: noop,
}

function mapStateToProps({ userDetailsReducer, transientReducer }) {
	return {
		loader: userDetailsReducer?.loader,
		loaderSms: userDetailsReducer?.loaderSms,
		loaderDownload: userDetailsReducer?.loaderDownload,
		isFetching: transientReducer?.isFetching

	}
}
export default connect(mapStateToProps)(Ticket)

